import { use, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import Stepper from '../../../../../../ui/components/Stepper';
import { Link, useLocation, useParams } from 'react-router-dom';
import { getOrderDetails } from '../../../../../../api/orderAPI';
import { CartFooter } from '../../../../../cartItems/CartFooter';
import { DownPaymentSuccessForm } from './DownPaymentSuccessForm';
import { DirectDebitSetupComplete } from './DirectDebitSetUpComplete';
import { clearCart } from '../../../../../../features/cart/cartSlice';
import { setMandateData } from '../../../../../../features/paystack/mandateSlice';
import { DirectDebitOrderSuccessSkeleton } from './DirectDebitOrderSuccessSkeleton';
import { resetFullPayment } from '../../../../../../features/order/fullPaymentSlice';

const DirectDebitInitialized = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const orderId = new URLSearchParams(location.search).get('orderid');

  const {
    data: orderDetails,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ['paystackOrder', orderId?.orderId],
    queryFn: () => getOrderDetails(orderId),
    enabled: !!orderId,
  });

  const downPaymentSuccess = useSelector(
    (state) => state.fullPayment.downPaymentSuccess
  );

  const paystackOrderReference = useSelector(
    (state) => state.fullPayment.paystackOrderReference
  );

  useEffect(() => {
    if (downPaymentSuccess && paystackOrderReference) {
      dispatch(resetFullPayment());
      dispatch(setMandateData(null));
    }
  }, [downPaymentSuccess, paystackOrderReference, dispatch]);

  return (
    <div className="mx-8">
      <header className="w-full py-8 md:pt-16 text-center grid md:flex justify-center ">
        <Link to="/" className="w-[149px] mb-4 md:mb-0">
          <img
            src="/images/SST_LOGO_HORIZONTAL_WEB_DARK.svg"
            alt="SmallSmall Logo"
            loading="eager"
            className="motion-safe:transition-transform w-full"
          />
        </Link>
      </header>
      <Stepper currentStep={3} totalSteps={3} />

      <section className="mt-8 md:flex md:max-w-6xl mx-auto md:space-x-14 space-y-8 md:space-y-0 justify-between">
        {isFetching ? (
          <div className="flex flex-col gap-4 lg:flex-row justify-between items-center w-full">
            <DirectDebitOrderSuccessSkeleton />
            <DirectDebitOrderSuccessSkeleton />
          </div>
        ) : isError ? (
          <p className="text-red-600 text-center">
            Error loading order details.
          </p>
        ) : (
          <>
            <DownPaymentSuccessForm orderDetails={orderDetails} />
            <DirectDebitSetupComplete orderDetails={orderDetails} />
          </>
        )}
      </section>
      <CartFooter />
    </div>
  );
};

export default DirectDebitInitialized;
